/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface SetGraphAnnotationVisibility$Params {
  graphAnnotationID?: number;
  isVisible?: boolean;
}

export function SetGraphAnnotationVisibility(http: HttpClient, rootUrl: string, params?: SetGraphAnnotationVisibility$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, SetGraphAnnotationVisibility.PATH, 'post');
  if (params) {
    rb.query('graphAnnotationID', params.graphAnnotationID, {});
    rb.query('isVisible', params.isVisible, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

SetGraphAnnotationVisibility.PATH = '/api/Graph/SetGraphAnnotationVisibility';
